import { listen, qs, qsa, toggle } from '@fluorescent/dom';

export default function OptionButtons(els) {
  const groups = els.map(createOptionGroup);

  function destroy() {
    groups && groups.forEach(group => group());
  }

  return { groups, destroy };
}

function createOptionGroup(el) {
  const select = qs('select', el);
  const buttons = qsa('[data-button]', el);
  const buttonClick = listen(buttons, 'click', e => {
    e.preventDefault();
    const { button, swatchButton, label } = e.currentTarget.dataset;

    if (swatchButton) {
      const optionSelectedLabel = qs(
        '[data-swatch-selected]',
        e.currentTarget.closest('.product__option')
      );
      if (optionSelectedLabel) optionSelectedLabel.innerHTML = label;
    }

    buttons.forEach(btn =>
      toggle(btn, 'selected', btn.dataset.button === button)
    );

    const opt = qs(`[data-value-handle="${button}"]`, select);
    opt.selected = true;

    select.dispatchEvent(new Event('change'));
  });

  return () => buttonClick();
}
